export const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const resolveMessageTemplate = (dictionary, key) => {
  const entry = dictionary[key];
  if (typeof entry === 'string') return entry;
  return entry?.nameRu ?? String(key);
};

export const interpolateTrustedHtml = (template, vars = {}) =>
  Object.entries(vars).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, escapeHtml(value)),
    String(template),
  );

export const formatTrustedMessage = (template, vars = {}) =>
  interpolateTrustedHtml(template, vars);
